import { javaApiInstance } from 'functions/request';

// page — page number (default: 1)
// size — items per page (default: 20, max: 200)
// sort — amount desc (default) | amount asc | title asc | title desc
// genre - action_adventure, strategy_role_playing, puzzle_logic, cards_board_casino, casual_lifestyle, sports, educational (comma-separated, e.g. sports,educational)
// device_type — ios, android, web (comma-separated, e.g. ios,android)
// my_offers — true = only user's installed games (default: false)
// seed - to help API with randomization

export const fetchKarmaEarnGameListApi = params => javaApiInstance.get('/api/my/v1/karmaearn/games', { params });

export const fetchKarmaEarnOfferListApi = params => javaApiInstance.get('/api/my/v1/karmaearn/apps', { params });

// page — page number (default: 1)
// size — items per page (default: 20, max: 200)
// my_offers — true = only user's surveys (default: false)
export const fetchKarmaEarnSurveyListApi = params => javaApiInstance.get('/api/my/v1/karmaearn/surveys', { params });

export const trackKarmaEarnSurveyApi = ({ network, id }) =>
  javaApiInstance.post(`/api/my/v1/karmaearn/surveys/${network}/${id}`);
